var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFlecheRougePhoto = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 42.7 29.46"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#f4161d",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "2px",
  d: "M28.87,1.29c7.7,3.56,12.53,8.47,12.53,8.47C4.49,7.47,1.44,28.13,1.44,28.13"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#f4161d",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "2px",
  d: "M31.24,14.92s9.23-2.96,10.16-5.16"
})));
export default SvgFlecheRougePhoto;